<template>
  <div>
    <h1 class="p-lg">Branded Containers</h1>
    <div class="p-lg" style="background: #CCC;">
      <div
        v-for="colour in brandColours"
        :key="colour"
        class="mb-lg">
        <p><strong>&lt;BrandContainer :brandColour="{{ colour }}" /&gt;</strong></p>
        <BrandContainer
          :brandColour="colour"
        >
          <div class="text-black font-normal w-full mx-auto text-center p-4 md:p-8">
            Ex et exercitation ad aliqua fugiat. Aliqua anim officia ad ad cillum fugiat ad cupidatat ad
            incididunt exercitation esse id. Elit consectetur magna duis amet irure irure minim.
          </div>
        </BrandContainer>
      </div>
    </div>
  </div>
</template>

<script setup>
import BrandContainer from '@/components/library/containers/BrandContainer/BrandContainer.vue';
import { BRAND_COLOURS } from '@/utils/colours';

const brandColours = Object.keys(BRAND_COLOURS);
</script>
